export default "__VITE_ASSET__DTMpWoCp__"